export default __webpack_public_path__ + "static/media/Admin.c89041dd.png";